import { render, staticRenderFns } from "./NewLanguageModal.vue?vue&type=template&id=73a20888&scoped=true&"
import script from "./NewLanguageModal.vue?vue&type=script&lang=js&"
export * from "./NewLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./NewLanguageModal.vue?vue&type=style&index=0&id=73a20888&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a20888",
  null
  
)

export default component.exports